import { customInstance } from "#/_packages/umbrella/lib/orval/custom-instance.ts";
import type { AlgoliaSearchSettings } from "../types";

export async function getSearchSettings(): Promise<AlgoliaSearchSettings> {
	const response = await customInstance<AlgoliaSearchSettings>({
		method: "GET",
		url: "/api/algolia/settings",
	});

	return response.data;
}
